<template>
    <div id="UserMap">
        <v-marker-cluster ref="clusterRef">
            <l-marker
                    v-for="item in markers"
                    :key="item.id"
                    :lat-lng="item.position"
                    :icon="item.icon"
            >
                <l-popup>
                    <div @click="showPlace(item.id)">
                        {{ item.name }}
                    </div>
                </l-popup>
            </l-marker>
        </v-marker-cluster>
        <b-container fluid class = "footer text-center">
            {{ this.userName}}. {{ $t('MAP') }}.
            <span class="m-1" v-if="published"> {{ $t('PUBLISHED') }}</span>
            <span class="m-1" v-else>{{ $t('UNPUBLISHED') }}</span>
            <b-button class="m-1"  v-if="userName==curUserName" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
            v-on:closeHelp="showHelp=false"
            v-bind:helpName="helpName"
            v-if="showHelp"
        />

    </div>

</template>

<script>
import { BContainer, BButton } from 'bootstrap-vue';
import L from 'leaflet';
import { latLng } from "leaflet";
import { LMarker, LPopup } from "vue2-leaflet";
import Help from "./Help.vue";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "UserMap",
  components: {
    LMarker, LPopup, Help,
    BContainer, BButton,
   'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props: {
    map: Object
  },
  data: function() {
    return {
      zoom: 17,
      center: latLng(0, 0),
      posFromSrv: false,
      userName: '',
      curUserName: '',
      m: [],
      markers: [],
      lng: 0.0,
      lat: 0.0,
      published: true,
      blocked: false,
      helpName: 'HelpUserMap',
      showHelp: false,
      intLoc: this.$i18n.locale,
      all: false
    };
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    if(this.curUserName && (this.curUserName === this.userName || this.curUserName === 'admin') ) {
        this.published = this.$route.query.published === 'false' ? false: true;
        this.blocked = this.$route.query.blocked === 'true' ? true: false;
    }
    else {
        this.published = true;
        this.blocked = false;
    }
    this.posFromSrv = typeof this.$route.query.posFromSrv === 'undefined' ? true: false;
    this.all = typeof this.$route.query.all === 'undefined' ? true: false;
    this.zoom = this.$store.state.curPos.zoom;
    this.center = latLng(this.$store.state.curPos.lat, this.$store.state.curPos.lng);
    this.getUserMap();
  },
  methods: {
    async getUserMap(){
        this.markers = [];
        try {
            let intLoc = this.all ? this.intLoc : '';
            const response = await this.$http.get('/getUserMap', {
                params: {
                    userName: this.userName,
                    published: this.published,
                    blocked: this.blocked,
                    all: this.all,
                    intLoc: intLoc
                }
            });
            //console.log('S', response.data.curZoom, latLng(response.data.curLat,response.data.curLng),this.posFromSrv,this.all);
            if(this.posFromSrv) {
                if(this.all) {
                    //console.log(this.all, response.data.north, response.data.east, response.data.south, response.data.west);
                     if(response.data.markList.length === 0) {
                         this.zoom = this.$zoomIni;
                         if(this.intLoc == 'en')
                            this.center = latLng(this.$latIniEn, this.$lngIniEn);
                         else
                             this.center = latLng(this.$latIniRu, this.$lngIniRu);
                         this.map.setView(this.center, this.zoom);
                    }
                    else if(response.data.markList.length === 1) {
                        this.zoom = 17;
                        this.center = latLng(response.data.curLat,response.data.curLng);
                        this.map.setView(this.center, this.zoom);
                    }
                    else {
                        this.map.fitBounds( [[ response.data.north, response.data.east ], [ response.data.south, response.data.west]] )
                        this.zoom = this.map.getZoom();
                        this.center = this.map.getCenter();
                    }
                }
                else {
                    this.zoom = response.data.curZoom;
                    if(this.zoom == 3) {
                        this.zoom = this.$zoomIni;
                        if(this.intLoc == 'en')
                            this.center = latLng(this.$latIniEn, this.$lngIniEn);
                        else
                            this.center = latLng(this.$latIniRu, this.$lngIniRu);
                    }
                    else {
                        if(this.zoom < 10) this.zoom = 10;
                        this.center = latLng(response.data.curLat,response.data.curLng);
                    }
                    this.map.setView(this.center, this.zoom);
                }
            } else {
                // Take data from store
                this.map.setView(this.center, this.zoom);
            }
            //this.$emit('setPos');
            if(typeof response.data.markList != 'undefined') {
                this.m = response.data.markList;
                this.showMapMarkers();
            }
            else {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('UserMap: getUserMap() '+error.message);
            this.$showErr(error.response.data, error.response.status);
        }
    },
    showMapMarkers() {
        for(let i = 0; i < this.m.length; i++) {
            let item = {
                id: i,
                name: this.m[i].markName,
                position: latLng(this.m[i].markLat,this.m[i].markLng),
                icon: L.icon({
                    iconUrl : '/data/markers/'+this.m[i].markType+'.png',
                    iconSize : [35, 41],
                    iconAnchor : [12, 37]
                })

            };
            this.markers.push(item);
        }
    },
    showPlace(itemId) {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.m[itemId].markName)+'/'+this.$addEncHyp(this.userName)
        })
    }
  },
  watch: {
/*
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.posFromSrv = false;
        this.getUserMap();
    },
*/
  }
};
</script>
<style >
    .footer{
        font-size:1rem;
        color:white;
    }

</style>